import React from "react";
import "./participants_list.css";
import { ParticipantsTable } from "../../components/participants_components/participants";

const ParticipantsList = (props) => {
  return <ParticipantsTable {...props} />;
};

export default ParticipantsList;
